export default {"links":"ypTDE","linkItem":"_1cL8M","logo":"Pgici","isSelected":"WExXr","logoImage":"tDPzh","pictureWrapper":"_8pYBm"};